var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Drop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3125 4.48128C15.1536 3.14363 13.8521 1.93648 12.4313 0.881284C12.3045 0.7938 12.154 0.746948 12 0.746948C11.846 0.746948 11.6955 0.7938 11.5688 0.881284C10.1479 1.93648 8.8464 3.14363 7.6875 4.48128C5.10938 7.43441 3.75 10.5563 3.75 13.5C3.75 15.6881 4.61919 17.7865 6.16637 19.3337C7.71354 20.8808 9.81196 21.75 12 21.75C14.188 21.75 16.2865 20.8808 17.8336 19.3337C19.3808 17.7865 20.25 15.6881 20.25 13.5C20.25 10.5563 18.8906 7.43441 16.3125 4.48128ZM17.175 14.3813C16.9932 15.453 16.482 16.4415 15.7125 17.2093C14.943 17.9771 13.9534 18.4862 12.8812 18.6657H12.7594C12.5704 18.6666 12.388 18.5962 12.2488 18.4684C12.1095 18.3407 12.0236 18.1651 12.0082 17.9768C11.9928 17.7884 12.049 17.6012 12.1657 17.4526C12.2824 17.3039 12.4509 17.2048 12.6375 17.175C13.4017 17.0471 14.1069 16.6839 14.6547 16.136C15.2026 15.5881 15.5658 14.883 15.6937 14.1188C15.7107 14.0214 15.7468 13.9283 15.7998 13.8449C15.8529 13.7615 15.9219 13.6894 16.003 13.6328C16.084 13.5762 16.1754 13.5361 16.272 13.5149C16.3685 13.4938 16.4683 13.4919 16.5656 13.5094C16.6636 13.5252 16.7574 13.5605 16.8414 13.6132C16.9255 13.6659 16.9981 13.735 17.0549 13.8163C17.1117 13.8977 17.1517 13.9896 17.1723 14.0866C17.1929 14.1837 17.1938 14.2839 17.175 14.3813Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.ede1b020ea2bf5e5d3714dccd0fd4b5c.svg";
export { ForwardRef as ReactComponent };